 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		33: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		33: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"vendors~components-Champions~components-Leaderboards-LeaderboardsPage~components-StatsTables-Combat~~cb0e57cc","1":"components-Champions~components-Items-Items~components-StatsTables~components-SummonerProfiles-views~54e0a909","2":"components-Champions-Overview~components-SummonerProfiles-views-LiveGame-LiveGameMain~components-Sum~a9e3c410","3":"components-Champions~components-Items-Items~components-StatsTables","4":"components-SummonerProfiles-views-LiveGame-LiveGameMain","5":"vendors~components-Accounts-Settings-Settings~components-Premium-views-PremiumCheckout","6":"components-Accounts-PasswordReset-PasswordReset","7":"components-Accounts-RecoverAccount-RecoverAccount","8":"components-Accounts-Settings-Settings","9":"components-Careers","10":"components-Champions","11":"components-Champions-ItemsTable-ItemsTableContainer","12":"components-Champions-Overview","13":"components-Champions-RunesGuide-RunesGuideContainer","14":"components-DesktopAppSplashPage-DesktopAppSplashPage","15":"components-Items-Items","16":"components-Leaderboards-LeaderboardsPage","17":"components-Pages-About-About","18":"components-Pages-EmailVerificationPage-EmailVerificationPage","19":"components-Pages-FAQ","20":"components-Pages-LandingPage-LandingPageContainer","21":"components-Pages-SupportUs-SupportUsPage","22":"components-Premium-views-PremiumCheckout","23":"components-PrivacyPolicy","24":"components-PrivacyShield","25":"components-StatsTables","26":"components-StatsTables-Combat","27":"components-StatsTables-DuoTierList","28":"components-StatsTables-Objectives","29":"components-StatsTables-TierList","30":"components-SummonerProfiles-views-LiveGame-LiveGameSplash","31":"components-SummonerProfiles-views-ProfilesMain-SummonerProfile","32":"components-TermsOfService","34":"vendors~components-Champions","35":"vendors~components-Pages-About-About","36":"vendors~components-SummonerProfiles-views-LiveGame-LiveGameSplash"}[chunkId]||chunkId) + "." + {"0":"a7e0992696dd89d7ca39","1":"d0d0ef611e049720034e","2":"a2cbbab28ca287186300","3":"468a5a81b537776c81ab","4":"8b210d90919d848431de","5":"f2f47e8f0e2049ac6a33","6":"5c5cb5c90a338f85c16e","7":"93686edadefd532a4432","8":"f1c4259a0e583d8099dd","9":"71d037677c96b588b596","10":"6fcc1d0df9bd8b0f7b5b","11":"adebd2bb1ffa842ff1df","12":"d6b34d86ab915362caad","13":"6f7bf63cf0e006ae1140","14":"a8ca5d88a3b7873d6a4b","15":"0dd571231f2aa393cd78","16":"10511c6fcb41508ac374","17":"defb1c617dbb18f0e073","18":"3ada0f02e617dc01d738","19":"86e76120cc1bfca62a4b","20":"21da5643f6b6cc66262f","21":"2c8e015d3a8b7747c910","22":"c4c1af351534826ab7fd","23":"abd97bf70b3b3f6c421b","24":"d37cdf1a4404f46c8733","25":"ade85ea14d1a1a0dc47c","26":"6161ba7582929114f1f0","27":"04aedd27233ae101ee93","28":"f34c8a0411aff677c989","29":"5fe2480c862fc74da097","30":"8dc360328b92c21d6b9f","31":"3aa1dabb65aaa6f3d129","32":"52f9f2845b963f24ad6b","34":"d8f84345960162525a4a","35":"97c620bc1d16310aacf3","36":"800fa1c4644a3489efe2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"35":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"0":"vendors~components-Champions~components-Leaderboards-LeaderboardsPage~components-StatsTables-Combat~~cb0e57cc","1":"components-Champions~components-Items-Items~components-StatsTables~components-SummonerProfiles-views~54e0a909","2":"components-Champions-Overview~components-SummonerProfiles-views-LiveGame-LiveGameMain~components-Sum~a9e3c410","3":"components-Champions~components-Items-Items~components-StatsTables","4":"components-SummonerProfiles-views-LiveGame-LiveGameMain","5":"vendors~components-Accounts-Settings-Settings~components-Premium-views-PremiumCheckout","6":"components-Accounts-PasswordReset-PasswordReset","7":"components-Accounts-RecoverAccount-RecoverAccount","8":"components-Accounts-Settings-Settings","9":"components-Careers","10":"components-Champions","11":"components-Champions-ItemsTable-ItemsTableContainer","12":"components-Champions-Overview","13":"components-Champions-RunesGuide-RunesGuideContainer","14":"components-DesktopAppSplashPage-DesktopAppSplashPage","15":"components-Items-Items","16":"components-Leaderboards-LeaderboardsPage","17":"components-Pages-About-About","18":"components-Pages-EmailVerificationPage-EmailVerificationPage","19":"components-Pages-FAQ","20":"components-Pages-LandingPage-LandingPageContainer","21":"components-Pages-SupportUs-SupportUsPage","22":"components-Premium-views-PremiumCheckout","23":"components-PrivacyPolicy","24":"components-PrivacyShield","25":"components-StatsTables","26":"components-StatsTables-Combat","27":"components-StatsTables-DuoTierList","28":"components-StatsTables-Objectives","29":"components-StatsTables-TierList","30":"components-SummonerProfiles-views-LiveGame-LiveGameSplash","31":"components-SummonerProfiles-views-ProfilesMain-SummonerProfile","32":"components-TermsOfService","34":"vendors~components-Champions","35":"vendors~components-Pages-About-About","36":"vendors~components-SummonerProfiles-views-LiveGame-LiveGameSplash"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"c84267a7d3b7edd22693","36":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.bigbrain.gg/lol/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([1163,37]);
 	// run deferred modules when ready
 	return checkDeferredModules();
